module.exports = __webpack_public_path__ + "static/media/DownwardArrow.1b75066d.svg";